const baseUrl = '/allocations-api/api/';
const submeterchargesUrlPartial = 'submetercharges';
const submeterBillingUrlPartial = 'submeter-billing';
const submeterBillingUnitMeterMapsUrlPartial = 'submeter-billing/unit-meter-maps';
export const allocationsRoutes = {
  addBillingCycles: propertyId => "Allocations/".concat(propertyId, "/billingCycles"),
  allocationComparison: 'Allocations/AllocationComparison',
  allocationHistory: 'Allocations/allocation-history',
  allocationPreview: 'Allocations/allocation-tables-preview',
  approveTable: 'Allocations/approval',
  baseUrl: "".concat(baseUrl),
  billingCycles: propertyId => "Allocations/".concat(propertyId, "/billingCycles"),
  billingSummary: '/Allocations/billingSummary',
  billsAllocations: 'Allocations/billsAllocations',
  billsFileCabinet: 'FileCabinet/bills',
  currentCycle: companyId => "AllocationCycle/".concat(companyId, "/current"),
  customBillingCycle: propertyId => "Allocations/".concat(propertyId, "/customBillingCycle"),
  deleteBillingCycle: (billingCycleId, property) => "Allocations/".concat(property, "/billingCycles/").concat(billingCycleId),
  excludeCorrection: correctionId => "correction/".concat(correctionId, "/exclude"),
  fileAttached: 'Bills',
  history: companyId => "AllocationCycle/".concat(companyId),
  includeCorrection: correctionId => "correction/".concat(correctionId, "/include"),
  propertyBillsFileCabinet: propertyId => "FileCabinet/bills/".concat(propertyId),
  review: 'Allocations/review',
  utilityAllocationExport: 'Reports/utility-allocation-export',
  skippedCycles: propertyId => "Allocations/".concat(propertyId, "/skippedCycles"),
  allocationTableInfo: 'allocations/allocationTablesInfo',
  allocationTableAggregate: 'allocations/allocationTable',
  submeterChargesBatch: "".concat(submeterchargesUrlPartial, "/batch"),
  postSubMeterHistory: "".concat(submeterchargesUrlPartial, "/history"),
  postGetSubMeterFinalState: "".concat(submeterchargesUrlPartial, "/get-final-state"),
  postGetSubmeterChargesFinalState: "".concat(submeterchargesUrlPartial, "/get-charges-final-state"),
  getSubmeterUnitMap: "".concat(submeterchargesUrlPartial, "/unit-map"),
  postSubmeterUnitMap: "".concat(submeterchargesUrlPartial, "/unit-map"),
  getSubmeterCsvMaps: "".concat(submeterchargesUrlPartial, "/csv-maps"),
  postSubmeterCsvMap: "".concat(submeterchargesUrlPartial, "/csv-map"),
  postSubmeterParseCsv: "".concat(submeterchargesUrlPartial, "/parse-csv"),
  postSubmeterBillingParseCsv: "".concat(submeterBillingUrlPartial, "/parse-csv"),
  getSubmeterBillingAllocations: "".concat(submeterBillingUrlPartial, "/allocations"),
  postSubmeterBillingAllocationsSave: "".concat(submeterBillingUrlPartial, "/allocations/save"),
  putSubmeterBillingAllocations: "".concat(submeterBillingUrlPartial, "/allocations"),
  postSubmeterBillingAllocationsApprove: "".concat(submeterBillingUrlPartial, "/allocations/approve"),
  getSubmeterBillingCsvMaps: propertyUtilityId => "".concat(submeterBillingUrlPartial, "/csv-map/list/").concat(propertyUtilityId),
  getSubmeterBillingCsvMap: id => "".concat(submeterBillingUrlPartial, "/csv-map/").concat(id),
  postSubmeterBillingCsvMap: "".concat(submeterBillingUrlPartial, "/csv-map"),
  putSubmeterBillingCsvMap: id => "".concat(submeterBillingUrlPartial, "/csv-map/").concat(id),
  deleteSubmeterBillingCsvMap: id => "".concat(submeterBillingUrlPartial, "/csv-map/").concat(id),
  getSubmeterBillingUnitMeterMaps: propertyUtilityId => "".concat(submeterBillingUnitMeterMapsUrlPartial, "/list/").concat(propertyUtilityId),
  postSubmeterBillingUnitMeterMapsByPropertyUtility: propertyUtilityId => "".concat(submeterBillingUnitMeterMapsUrlPartial, "/by-property-utility/").concat(propertyUtilityId),
  deleteSubmeterBillingUnitMeterMapsByPropertyUtility: propertyUtilityId => "".concat(submeterBillingUnitMeterMapsUrlPartial, "/by-property-utility/").concat(propertyUtilityId),
  postSubmeterBillingUnitMeterMapsBatch: "".concat(submeterBillingUnitMeterMapsUrlPartial, "/batch")
};